
export const genderOptions = [
    { value: 'male', label: 'Male' },
    { value: 'female', label: 'Female' },
    { value: 'others', label: 'Others' }
];

export const retirementOptions = [
    { value: "age_limit", label: "Age limit" }, 
    { value: "years_of_service", label: "years of service" },
    { value: "medical", label: "Medical" },
    { value: "voluntary", label: "Voluntary" },
    { value: "mandatory", label: "Mandatory" },
    { value: "others", label: "Others" }
];

export const policyOptions = [
    { value: 'double_employment', label: 'Double employment' },
    { value: 'allow_only_one_pay', label: 'Allow only One pay' },
];


export const transferOptions = [
    { value: 'interstate', label: 'Interstate' },
    { value: 'civil_service', label: 'Civil service' },
    { value: 'mda', label: 'MDA' },
    { value: 'department', label: 'Department' },
];

export const appointmentTypes = [
    { label: "Permanent", value: "Permanent" },
    { label: "Confirmed", value: "Confirmed" },
    { label: "Probation", value: "Probation" },
    { label: "Contract", value: "Contract" },
    { label: "Temporary", value: "Temporary" },
    { label: "Full-time", value: "Full-time" },
    { label: "Part-time", value: "Part-time" },
    { label: "Visiting", value: "Visiting" },
    { label: "Adjunct", value: "Adjunct" },
    { label: "Sabbatical", value: "Sabbatical" },
    { label: "Graduate Assistant", value: "Graduate Assistant" },
    { label: "Research Assistant", value: "Research Assistant" },
    { label: "Teaching Assistant", value: "Teaching Assistant" },
    { label: "Consultancy", value: "Consultancy" },
    { label: "Internship", value: "Internship" },
    { label: "National Youth Service (NYSC)", value: "National Youth Service (NYSC)" },
];

export const publicationTypes = [
    {   label:"Journal Article",value:"journal_article"},
    {   label:"Book",value:"book"},
    {   label:"Book Chapter",value:"book_chapter"},
    {   label:"Conference Proceeding",value:"conference_proceeding"},
    {   label:"Patent",value:"patent"},
    {   label:"Technical Report",value:"technical_report"}
];